import { Helmet } from "react-helmet";
import { useParams, useNavigate } from "react-router-dom";
import { Project, projects } from '../../constants/projects'
import ProjectDetailInfo from "../../components/sections/projectSection/ProjectDetailInfo";
import BaseSection from "../../components/sections/BaseSection";
import routes from "../../constants/routes";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { media } from "../../constants/styles";
import ProjectInvolveInfo from "../../components/sections/projectSection/ProjectInvolveInfo";
import NextProject from "../../components/sections/projectSection/NextProject";
import Footer from "../../components/Layout/Footer";

interface Props { }
const ProjectDetail: React.FC<Props> = () => {
  const { projectKey } = useParams();
  const navigate = useNavigate();
  const projectIdxRef = useRef<number | null>(null);
  const project = projects.find((proj, idx) => {
    projectIdxRef.current = idx;
    return proj.key === projectKey
  });
  const [nextProject, setNextProject] = useState<Project | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [projectKey]);

  useEffect(() => {
    project ?? navigate(routes.NOTFOUND);

    if (projectIdxRef.current === null) {
      return;
    }

    let nextProject = null;

    for (let i = projectIdxRef.current + 1; i < projects.length; i++) {
      nextProject = projects[i];
      if (nextProject?.isOpen) {
        break;
      }
      nextProject = null;
    }

    setNextProject(nextProject || null);
  }, [project])

  const handleHistoryBack = () => {
    navigate(routes.PROJECT);
  }

  return project ? (
    <>
      <Helmet>
        <title>Slogup - Project detail</title>
      </Helmet>
      <ProjectHeader>
        <div className="project-header-inner">
          <div className="project-header-left">
            <img height={"100%"} width={"auto"} src={project.logoSrc} alt={project.title} />
          </div>
          <div className="project-header-right" onClick={handleHistoryBack}>
            <img width={"100%"} height={"auto"} src="/image/icon/close.svg" alt="close" />
          </div>
        </div>
      </ProjectHeader>
      <MainBanner banner={project.detailBanner} />
      <BaseSection fullWidth>
        <ProjectDetailInfo info={project.info} />
        {project.content}
        {project.info.involve && Object.keys(project.info.involve).length && <ProjectInvolveInfo info={project.info.involve} interviewLink={project.info.interviewLink} />}
        {nextProject && <NextProject info={nextProject} />}
      </BaseSection>
      <Footer />
    </>
  ) : null
};

export default ProjectDetail;

const ProjectHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 32px 0px;
  z-index: 100;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.00) 100%);

  .project-header-inner {
    width: 100%;
    max-width: 1296px;
    margin: 0 auto;
    padding: 0 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .project-header-left {
    height: 24px;
  }

  .project-header-right {
    width: 48px;
    cursor: pointer;
  }

  ${media.MOBILE}{
    padding: 18px 0px;

    .project-header-inner {
      padding: 0 24px;
    }

    .project-header-left {
      height: 20px;
    }

    .project-header-right {
      width: 24px;
    }
  }
`;

const MainBanner = styled.div<{ banner: { pc: string, tablet: string, mobile: string } }>`
  background-size: cover;
  height: 100vh;
  width: 100%;
  background-image: url(${({ banner }) => banner.pc});
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
  
  ${media.TABLET}{
    background-image: url(${({ banner }) => banner.tablet});
  }
  ${media.MOBILE}{
    background-image: url(${({ banner }) => banner.mobile});
  }

`